<template>
    <div class="col-md-60">
        <div class="row">
            <form role="form"  method="POST" action="/cabinet/data/car_update/" target="form_submit" ><!--  -->
                <div class="col-md-120" style="min-height: 38em">
                    <div class="thumbnail zero-padding clearfix ">
                        <div class="thumbnail_head" style="margin-bottom: 1em">
                            <img :src="car.carlogo ? car.carlogo : '/static/img/cabinet/audi_logo.png'" class="audi_logo">
                            <p class="markaauto" >{{car.namebrend}}  {{car.namemodel}}</p>
                        </div>
                        <div class="col-md-120">
                            <div class="row">
                                <div class="col-md-60 parent">

                                    <div class="form-group clearfix">
                                        <select  class="js-example-brend form-control " v-model="car.autoBrand_id" name="marka" >
                                            <option :value="car.autoBrand_id" v-if="car.autoBrand_id" >{{ car.namebrend }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group clearfix">
                                        <select  class="js-example-model form-control " v-model="car.autoModel_id" name="model" >
                                            <option :value="car.autoModel_id" v-if="car.autoModel_id" >{{ car.namemodel }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group clearfix year_issue">

                                        <input type="text"
                                               data-default-date="00-00-0000"
                                               data-large-default="true"
                                               data-max-year="2030"
                                               data-format = "Y"
                                               class="form-control dates" name="year_issue" v-model="car.year_issue"
                                        >

                                    </div>
                                    <div class="form-group clearfix">
                                        <input type="text" class="form-control"
                                               placeholder="VIN: JHLRE48577C415490" name="vin" v-model="car.vin"
                                        >
                                    </div>
                                    <div class="form-group clearfix">
                                        <input type="text" class="form-control"
                                               placeholder="Гос. номер: О376ОР199"
                                               name="number_gos" v-model="car.number_gos"
                                        >
                                    </div>
                                </div>
                                <div class="col-md-60">
                                    <div class="form-group clearfix">
                                        <input type="text" class="form-control"
                                               placeholder="Летняя: 185/60 R15"
                                               name="tires_summer" v-model="car.tires_summer"
                                        >
                                    </div>
                                    <div class="form-group clearfix">
                                        <input type="text" class="form-control"
                                               placeholder="Зимняя: 205/55 R16"
                                               name="tires_winter" v-model="car.tires_winter"
                                        >
                                    </div>
                                    <div class="form-group clearfix osago_do">

                                        <input type="date" name="osago_do"
                                               v-model="car.osago_do"
                                               class="form-control"
                                        >

                                    </div>
                                    <div class="form-group clearfix">
                                        <input type="text" class="form-control"
                                               placeholder="ОСАГО от: РЕСО Ганрантия"
                                               name="osago_strah"
                                               v-model="car.osago_strah"
                                        >
                                    </div>
                                    <div class="form-group clearfix kasko_do">

                                        <input type="date" name="kasko_do"
                                               class="form-control" v-model="car.kasko_do"
                                        >

                                    </div>
                                    <div class="form-group clearfix">
                                        <input type="text" class="form-control"
                                               placeholder="КАСКО от: ВА-Гарант"
                                               name="kasko_strah" v-model="car.kasko_strah"
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!noedit">
                            <button class="btn btn-primary btn_auto_form" style="margin-top: 0.3em;">Сохранить</button>
                        </div>
                    </div>
                </div>
                <input type="hidden" v-model="car.id" name="id" >
            </form>
        </div>
    </div>
</template>

<script>
export default {
  name: 'cars',
  props: ['car', 'city', 'user', 'auth'],
  data () {
    return {}
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cabinet/user/cars.vue